import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { MatExpansionPanel } from "@angular/material";

@Component({
  selector: "app-common-alert-dialog",
  templateUrl: "./common-alert-dialog.component.html",
  styleUrls: ["./common-alert-dialog.component.css"],
})
export class CommonAlertDialogComponent implements OnInit {
  @ViewChild("freePanel") freezePanel: MatExpansionPanel;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<CommonAlertDialogComponent>
  ) {}

  ngOnInit() {}
  onMainHeaderClose() {
    this.freezePanel.open();
  }
  closeDialog(value: boolean) {
    this.dialogRef.close(value);
  }

  onConfirmChange(value: boolean) {
    this.closeDialog(value);
  }
}
